<template>
<div v-if="account && account.length > 1">
  <a
    :key="account"
    data-tweet-limit="5"
    :data-lang="locale"
    :data-theme="'light'"
    :data-link-color="ColorContent"
    :href="`https://twitter.com/${account}?ref_src=twsrc%5Etfw`"
    class="twitter-timeline"
  >
    {{ account }} tweets
  </a>
</div>
</template>

<script>
  import {
    mapState
  } from 'vuex'
  export default {
    props: {
      account: {
        type: String,
        required: false,
        default: null,
      },
    },
    data: () => ({
      recaptchaScript: null
    }),
    computed: {
      ...mapState('app',['locale', 'FontContent', 'FontSizeContent', 'ColorContent']),
    },
    mounted () {
      this.resetScript()
    },
    updated () {
      this.resetScript()
    },
    methods:{
      resetScript () {
        if(this.recaptchaScript) document.head.removeChild(this.recaptchaScript)
        // INI script para la integración de twitter
        let script = 'https://platform.twitter.com/widgets.js'
        this.recaptchaScript = document.createElement('script')
        this.recaptchaScript.setAttribute('src', script)
        document.head.appendChild(this.recaptchaScript)
        // END script para la integración de twitter
      }
    }
  }
</script>
<style scoped>
</style>
